<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
        v-if="isAdding"
      >
        <radius-accounts
          v-model="userService.radiusAccountId"
        ></radius-accounts>
      </v-col>
      <v-col cols="12" class="pt-0 mt-0 pb-0">
        <ValidationProvider
          v-slot="{ errors }"
          name="Search for Address"
          rules="required"
        >
          <v-autocomplete
            :items="addressResults"
            label="Search for physical street Address, not PO Box"
            :search-input.sync="value"
            item-text="formattedAddress"
            item-value="formattedAddress"
            @change="completeAddress"
            persistent-hint
            autocomplete="off"
            :error-messages="errors"
            no-filter
            return-object
          >
          </v-autocomplete>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
        v-if="!isAdding"
      >
        <ValidationProvider name="Service Name" immediate>
          <v-text-field
            v-model="userService.serviceName"
            label="Service Name"
            placeholder=" "
            outlined
            persistent-hint
            autocomplete="off"
            color="dark"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        lg="3"
        :class="$vuetify.breakpoint.smAndDown ? 'py-1' : 'py-1'"
      >
        <ValidationProvider name="Street" immediate>
          <v-text-field
            v-model="userService.serviceStreet"
            label="Street Address"
            placeholder=" "
            disabled
            outlined
            persistent-hint
            autocomplete="off"
            color="dark"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        lg="3"
        :class="$vuetify.breakpoint.smAndDown ? 'py-1' : 'py-1'"
      >
        <ValidationProvider name="City" immediate>
          <v-text-field
            v-model="userService.serviceCity"
            label="City"
            placeholder=" "
            outlined
            disabled
            persistent-hint
            autocomplete="off"
            color="dark"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        lg="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
      >
        <ValidationProvider name="Billing Reference" immediate>
          <v-text-field
            placeholder=" "
            label="Billing Reference"
            outlined
            persistent-hint
            v-model="userService.supplierBillingReference"
            :disabled="!isAdding"
            autocomplete="off"
            color="dark"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RadiusAccounts from "@/components/ServiceDetails/RadiusAccounts";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "nbn-options",
  components: { RadiusAccounts },
  props: {
    isAdding: { type: Boolean, required: true },
    userService: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.userService.serviceStreet = this.userService.serviceStreet || "";
    this.userService.serviceCity = this.userService.serviceCity || "";
  },
  computed: {
    ...mapGetters("address", ["addressResults"]),
  },
  data() {
    return {
      value: null,
      streetAddress: "",
      invalidItems: [],
    };
  },
  watch: {
    value: function (val) {
      let vm = this;
      if (val !== null) {
        if (val.length > 4) vm.searchAddress(val);
      }
    },
  },
  methods: {
    ...mapActions("address", ["getFullAddress", "searchAddress"]),
    completeAddress(address) {
      let vm = this;
      // vm.$emit("changed");
      vm.getFullAddress(address.formattedAddress).then((addressResults) => {
        this.userService.serviceStreet =
          addressResults.data.result.street_address || "";
        this.userService.serviceCity = addressResults.data.result.city || addressResults.data.result.suburb;
        this.$emit('trigger-validation');
      });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>